// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__h47Oh","icon":"Loading_icon__INzWT"};